var _PdfCertificateTable = /** @class */ (function () {
    function _PdfCertificateTable() {
        this._orig = new Map(); // eslint-disable-line
        this._orig = new Map();
        this._keys = new Map();
    }
    _PdfCertificateTable.prototype._getKeys = function () {
        var result = [];
        this._orig.forEach(function (value, key) {
            result.push(key);
        });
        return result;
    };
    _PdfCertificateTable.prototype._clear = function () {
        this._orig.clear();
        this._keys.clear();
    };
    _PdfCertificateTable.prototype._remove = function (key) {
        var lower = key.toLowerCase();
        var actualKey;
        this._keys.forEach(function (mappedKey, tempKey) {
            if (tempKey.toLowerCase() === lower) {
                actualKey = mappedKey;
            }
        });
        if (!actualKey) {
            return null;
        }
        this._keys.delete(lower);
        var value = this._orig.get(actualKey);
        this._orig.delete(actualKey);
        return value;
    };
    _PdfCertificateTable.prototype._get = function (key) {
        var lower = key.toLowerCase();
        var actualKey;
        var entries = []; // eslint-disable-line
        this._keys.forEach(function (value, key) {
            entries.push([key, value]);
        });
        for (var i = 0; i < entries.length; i++) {
            var _a = entries[i], tempKey = _a[0], mappedKey = _a[1];
            if (tempKey.toLowerCase() === lower) {
                actualKey = mappedKey;
                break;
            }
        }
        return actualKey ? this._orig.get(actualKey) : null;
    };
    _PdfCertificateTable.prototype._setValue = function (key, value) {
        var lower = key.toLowerCase();
        var existingKey;
        var entries = []; // eslint-disable-line
        this._keys.forEach(function (value, key) {
            entries.push([key, value]);
        });
        for (var i = 0; i < entries.length; i++) {
            var _a = entries[i], tempKey = _a[0], mappedKey = _a[1];
            if (tempKey.toLowerCase() === lower) {
                existingKey = mappedKey;
                break;
            }
        }
        if (existingKey) {
            this._orig.delete(existingKey);
        }
        this._keys.set(lower, key);
        this._orig.set(key, value);
    };
    return _PdfCertificateTable;
}());
export { _PdfCertificateTable };
